import { render, staticRenderFns } from "./UserModerationOverlay.vue?vue&type=template&id=831e2dae&scoped=true&"
import script from "./UserModerationOverlay.vue?vue&type=script&lang=ts&"
export * from "./UserModerationOverlay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "831e2dae",
  null
  
)

export default component.exports